import React, { useState } from 'react';

import { faPlus, faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Title, Group, Button, TextInput } from '@mantine/core';
import { Link } from 'react-router-dom';

import CallerList from '../components/caller/CallerList';

const ManageCallers: React.FC = () => {
  const [searchInput, setSearchInput] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchSubmit = () => {
    setSearchTerm(searchInput.trim());
  };

  const handleClearSearch = () => {
    setSearchInput('');
    setSearchTerm('');
  };

  return (
    <>
      <Group justify="space-between" mb="xl">
        <Title order={1}>Manage Callers</Title>
        <Button
          component={Link}
          leftSection={<FontAwesomeIcon icon={faPlus} />}
          to="/caller/add"
          variant="filled"
        >
          Add Caller
        </Button>
      </Group>

      <Group gap="xs" mb="md" wrap="nowrap">
        <TextInput
          flex={1}
          leftSection={<FontAwesomeIcon icon={faSearch} />}
          placeholder="Name search"
          size="md"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit()}
        />
        <Button size="md" variant="light" onClick={handleSearchSubmit}>
          Search
        </Button>
        {(searchInput || searchTerm) && (
          <Button
            color="gray"
            leftSection={<FontAwesomeIcon icon={faXmark} />}
            size="md"
            variant="subtle"
            onClick={handleClearSearch}
          >
            Clear
          </Button>
        )}
      </Group>

      <CallerList search={searchTerm || undefined} title="Callers" />
    </>
  );
};

export default ManageCallers;



